import toggleMobileMenu from './toggle-mobile-menu'

export default function header () {
  toggleMobileMenu()
}
